import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchUserFamilyById } from "../../../service/UserFamilyApi";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../../components/shared";
import { renderMemberTree, buildMemberHierarchy } from "../../../utils/Utilities";
import useCheckLoggedin from "../../../utils/useCheckLoggedin";

function FamilyView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyData, setFamilyData] = useState(null);
  const [error, setError] = useState(null);

  useCheckLoggedin();

  useEffect(() => {
    const fetchFamilyData = async () => {
      try {
        if (id) {
          const data = await fetchUserFamilyById(id); // Await the fetchFamilyById function
          setFamilyData(data); // Set the family data in state
        }
      } catch (error) {
        setError("Error fetching family data");
      }
    };

    fetchFamilyData(); // Call the async function inside useEffect
  }, [id]); // Only re-run if id changes

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  if (!familyData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Helmet>
        <title>View Family</title>
        <link rel="canonical" href={`/family/view/${id}`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            {/* Family Details Section */}
            <h3>குடும்ப விவரங்கள்</h3>
            <br />
            <br />
            <div className="details-card">
              <div className="detail-item">
                <span className="detail-label"><strong>கூட்டம்:</strong></span>
                <span>{familyData.family.kootamName || ""}</span>
              </div>

              {familyData.family.customGroup && (
                <div className="detail-item">
                  <span className="detail-label"><strong>மற்ற குழு:</strong></span>
                  <span>{familyData.family.customGroup}</span>
                </div>
              )}

              <div className="detail-item">
                <span className="detail-label"><strong>குடும்பத் தலைவர் ஆதார் எண்:</strong></span>
                <span style={{ color: familyData.family.familyHeadAadhar?.startsWith("TMP") ? "red" : "inherit" }}>
                  {familyData.family.familyHeadAadhar || ""}
                </span>

              </div>
              <div className="detail-item">
                <span className="detail-label"><strong>குடும்பத் தலைவர்:</strong></span>
                <span>
                  {familyData.family.familyHeadFirstName || ""}
                  {familyData.family.familyHeadLastName ? ` ${familyData.family.familyHeadLastName}` : ""}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label"><strong>மொபைல் எண்:</strong></span>
                <span>
                  {familyData.family.familyHeadMobile}
                  {familyData.family.familyHeadMobile && familyData.family.familyHeadMobile2 ? " / " : ""}
                  {familyData.family.familyHeadMobile2}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label"><strong>நிரந்தர அஞ்சல்:</strong></span>
                <span>{familyData.family.permanentAddressName_tamil || ""}{", "}{familyData.family.permanentAddressBlock_tamil || ""}{", "}{familyData.family.permanentAddressDistrict_tamil || ""}</span>
              </div>
              {familyData.family.tempAddressDistrict_tamil && (
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்காலிக அஞ்சல் :</strong></span>
                  <span>
                    {familyData.family.tempAddressName_tamil || ""}
                    {familyData.family.tempAddressBlock_tamil ? ", " + familyData.family.tempAddressBlock_tamil : ""}
                    {familyData.family.tempAddressDistrict_tamil ? ", " + familyData.family.tempAddressDistrict_tamil : ""}
                  </span>
                </div>
              )}
              {familyData.family.familyName && (
                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்பப் பெயர்:</strong></span>
                  <span>{familyData.family.familyName}</span>
                </div>
              )}
              <div className="detail-item">
                <span className="detail-label"><strong>நிலை:</strong></span>

                <span style={{ color: ['draft', 'inactive', 'pending'].includes(familyData.family.status) ? 'red' : 'inherit' }}>
                  {familyData.family.status || ""}
                </span>

              </div>
              {familyData?.family?.addressData?.tempAddress?.pincode && (
                <>
                  <hr></hr>
                  <div className="detail-item">
                    <span className="detail-label"><strong>தற்காலிக முகவரி :</strong></span>
                    <div>
                      {/* Check for tempAddressLine1, tempAddressLine2, tempAddressLine3 */}
                      <span>
                        {familyData?.family?.tempAddressLine1 && familyData.family.tempAddressLine1 + ','}
                        {familyData?.family?.tempAddressLine2 && familyData.family.tempAddressLine2 + ','}
                        {familyData?.family?.tempAddressLine3 && familyData.family.tempAddressLine3}
                      </span>
                      <br />
                      {/* Check for address data (name, block, district, state, country) */}
                      <span>
                        {familyData?.family?.addressData?.tempAddress?.subAreas[0].name
                          .split("|")
                          .reverse()
                          .map((token) => token + ",")}
                      </span>
                      <br />
                      <span>
                        {familyData?.family?.addressData?.tempAddress?.name && familyData.family.addressData.tempAddress.name + ', '}
                        {familyData?.family?.addressData?.tempAddress?.block && familyData.family.addressData.tempAddress.block + ', '}
                        {familyData?.family?.addressData?.tempAddress?.district && familyData.family.addressData.tempAddress.district + ', '}
                        {familyData?.family?.addressData?.tempAddress?.state && familyData.family.addressData.tempAddress.state + ', '}
                        {familyData?.family?.addressData?.tempAddress?.country && familyData.family.addressData.tempAddress.country}
                      </span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label"><strong></strong></span>
                    <div>
                      {/* Check for Tamil address lines */}
                      <span>
                        {familyData?.family?.tempAddressLine1_tamil && familyData.family.tempAddressLine1_tamil + ','}
                        {familyData?.family?.tempAddressLine2_tamil && familyData.family.tempAddressLine2_tamil + ','}
                        {familyData?.family?.tempAddressLine3_tamil && familyData.family.tempAddressLine3_tamil}

                      </span>
                      <br />
                      {/* Check for Tamil address data */}
                      <span>
                        {familyData?.family?.addressData?.tempAddress?.subAreas[0].name_tamil
                          .split("|")
                          .reverse()
                          .map((token) => token + ",")}
                      </span>
                      <br />
                      <span>
                        {familyData?.family?.addressData?.tempAddress?.name_tamil && familyData.family.addressData.tempAddress.name_tamil + ', '}
                        {familyData?.family?.addressData?.tempAddress?.block_tamil && familyData.family.addressData.tempAddress.block_tamil + ', '}
                        {familyData?.family?.addressData?.tempAddress?.district_tamil && familyData.family.addressData.tempAddress.district_tamil + ', '}
                        {familyData?.family?.addressData?.tempAddress?.state_tamil && familyData.family.addressData.tempAddress.state_tamil + ', '}
                        {familyData?.family?.addressData?.tempAddress?.country_tamil && familyData.family.addressData.tempAddress.country_tamil}
                      </span>

                      {/* Check for pincode */}
                      <span>
                        <br />
                        {familyData?.family?.addressData?.tempAddress?.pincode && familyData.family.addressData.tempAddress.pincode}
                      </span>
                    </div>
                  </div>
                </>
              )}

              <hr />

              <div className="detail-item">
                <span className="detail-label"><strong>நிரந்தர முகவரி:</strong></span>
                <div>
                  {/* Check for permanentAddressLine1, permanentAddressLine2, permanentAddressLine3 */}
                  <span>
                    {familyData?.family?.permanentAddressLine1 && familyData.family.permanentAddressLine1 + ','}
                    {familyData?.family?.permanentAddressLine2 && familyData.family.permanentAddressLine2 + ','}
                    {familyData?.family?.permanentAddressLine3 && familyData.family.permanentAddressLine3}
                  </span>
                  <br />
                  {/* Check for address data (name, block, district, state, country) */}
                  <span>
                    {familyData?.family?.addressData?.permanentAddress?.subAreas[0].name
                      .split("|")
                      .reverse()
                      .map((token) => token + ",")}
                  </span>
                  <br />
                  <span>
                    {familyData?.family?.addressData?.permanentAddress?.name && familyData.family.addressData.permanentAddress.name + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.block && familyData.family.addressData.permanentAddress.block + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.district && familyData.family.addressData.permanentAddress.district + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.state && familyData.family.addressData.permanentAddress.state + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.country && familyData.family.addressData.permanentAddress.country}

                  </span>
                </div>
              </div>
              <div className="detail-item">
                <span className="detail-label"><strong></strong></span>
                <div>
                  <span>
                    {familyData?.family?.permanentAddressLine1_tamil && familyData.family.permanentAddressLine1_tamil + ','}
                    {familyData?.family?.permanentAddressLine2_tamil && familyData.family.permanentAddressLine2_tamil + ','}
                    {familyData?.family?.permanentAddressLine3_tamil && familyData.family.permanentAddressLine3_tamil}
                  </span>
                  <br />
                  {/* Check for Tamil permanent address data */}
                  <span>
                    {familyData?.family?.addressData?.permanentAddress?.subAreas[0].name_tamil
                      .split("|")
                      .reverse()
                      .map((token) => token + ",")}
                  </span>
                  <br />
                  <span>

                    {familyData?.family?.addressData?.permanentAddress?.name_tamil && familyData.family.addressData.permanentAddress.name_tamil + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.block_tamil && familyData.family.addressData.permanentAddress.block_tamil + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.district_tamil && familyData.family.addressData.permanentAddress.district_tamil + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.state_tamil && familyData.family.addressData.permanentAddress.state_tamil + ', '}
                    {familyData?.family?.addressData?.permanentAddress?.country_tamil && familyData.family.addressData.permanentAddress.country_tamil}
                  </span>

                  {/* Check for pincode */}
                  <span>
                    <br />
                    {familyData?.family?.addressData?.permanentAddress?.pincode && familyData.family.addressData.permanentAddress.pincode}
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <br />
      {/* குடும்ப உறுப்பினர்கள் Table */}
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <h3>குடும்ப உறுப்பினர்கள்</h3>
            <div>
              {renderMemberTree(buildMemberHierarchy(familyData.family))}
            </div>
            <br />
            <div className="table-container">
              <table className="table" aria-label="Recent Families">
                <thead>
                  <tr>
                    <th>விவரங்கள்</th>
                    <th>செயல்கள்</th>
                  </tr>
                </thead>
                <tbody>
                  {familyData.family.familyMembers.map((member, index) => {
                    // Find the parent member based on parentId (assuming parentId matches with member's aadhar or id)
                    return (
                      <tr key={index}>
                        <td>
                          {member.firstName || ""} {member.lastName || ""}
                        </td>

                        <td>
                          <button type="button" onClick={() => navigate(`/user/family/member-view/${member.id}`)}>
                            👁️பார்க்க
                          </button>
                          <br />
                          <button type="button" onClick={() => navigate(`/user/family/member-update/${member.id}`)}>
                            ✏️  திருத்த
                          </button>
                          <br />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>



              </table>
              <div className="button-group">
                <button onClick={() => navigate(`/user/family/member-create/${id}`)}>குடும்ப உறுப்பினரைச் சேர்</button>
                <br />
                <button onClick={() => navigate(`/user/family/update/${id}`)}>குடும்பத்தை புதுப்பிக்கவும்</button>
                <br />
                <button onClick={() => navigate(`/user/family/address-update/${id}`)}>முகவரியை புதுப்பிக்கவும்</button>
              </div>
            </div>

            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல்</button>
          </div>
        </div>
      </div>



      <Footer />
    </>
  );
}

export default FamilyView;
